export default "__VITE_ASSET__CCTS7Exx__"